import defaultRenderEmpty from './renderEmpty';

export var ConfigConsumerProps = {
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return 'ant-' + suffixCls;
  },
  renderEmpty: defaultRenderEmpty
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/config-provider/configConsumerProps.js
// module id = null
// module chunks = 